import Tooltip from '@material-ui/core/Tooltip';
import React, { useEffect, useRef, useState } from 'react';

import LoaderComponent from '@components/LoaderComponent';
import { toastError } from '@components/Toast';

import ApiClient from '@lib/apiClient';

const AssignMemberToOrderStage = ({ memberList, taskInfo, onAddOrDeleteSuccess }) => {
	const [showAddNewMemberModal, setShowMemberModal] = useState(false);
	const [isLoading, setIsloading] = useState(false);
	const AddNewMemberButtonRef = useRef(null);
	const AddNewMemberModalRef = useRef(null);
	const moreMember = 3;

	useEffect(() => {
		document.addEventListener('click', handleClickOutside, { capture: true });
		return () => {
			document.removeEventListener('click', handleClickOutside);
		};
	}, []);

	const handleClickOutside = (event) => {
		if (
			AddNewMemberModalRef.current &&
			!AddNewMemberModalRef.current.contains(event.target) &&
			AddNewMemberButtonRef.current &&
			!AddNewMemberButtonRef.current.contains(event.target)
		) {
			setShowMemberModal(false);
		}
	};

	const isMemberAdded = (member) => {
		let flag = false;
		taskInfo.members &&
			taskInfo.members.map((taskMember) => {
				if (taskMember.id === member.memberId) {
					flag = true;
				}
			});
		return flag;
	};

	const addOrDeleteMember = async (member) => {
		setIsloading(true);
		await ApiClient.POST('addDeleteMemberToTask', {
			stepId: taskInfo.id,
			memberIdList: [member.memberId]
		})
			.then(({ data }) => {
				if (data.success) {
					setIsloading(false);
					let flag = true;
					taskInfo.members = taskInfo.members.filter((memberItem) => {
						if (memberItem.id === member.memberId) {
							flag = false;
						}
						return memberItem.id !== member.memberId;
					});
					if (flag) {
						taskInfo.members.push(member);
					}
					onAddOrDeleteSuccess();
				}
			})
			.catch(({ response }) => {
				setIsloading(false);
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Something went wrong! Please try again.');
				}
			});
	};

	return (
		<LoaderComponent loading={isLoading}>
			<div
				className="member-and-date d-flex justify-content-between align-items-center"
				onClick={() => setShowMemberModal(!showAddNewMemberModal)}
			>
				<div className="member mr-3">
					<div className="item">
						<div className="add-member-popup cursor-pointer">
							<Tooltip title="Assign member" placement="top-start" arrow>
								<img
									src={`${process.env.PUBLIC_URL}/icons/add-people.svg`}
									alt="add"
									ref={AddNewMemberButtonRef}
								/>
							</Tooltip>

							<div
								className={`assign-member shadow ${showAddNewMemberModal ? 'open' : ''}`}
								ref={AddNewMemberModalRef}
							>
								<div className="title">Assign member</div>
								<div className="member-list-container scroll-y-label">
									{memberList && memberList.length ? (
										memberList.map((member) => {
											return (
												<div
													key={member.memberId}
													className="member-list"
													onClick={() => addOrDeleteMember(member)}
												>
													{member.memberImage ? (
														<img src={member.memberImage} alt="" />
													) : (
														<img
															src={`${process.env.PUBLIC_URL}/images/pro_pic_default.svg`}
															alt=""
														/>
													)}
													<div className="name">
														{member.memberName}{' '}
														{member.designation && (
															<span className="tag">
																{member.primaryUserType === 'BUYER'
																	? 'Buyer'
																	: member.designation}
															</span>
														)}
													</div>
													{isMemberAdded(member) ? (
														<div className="checked">
															<div className="d-block">
																<svg
																	width="18"
																	height="13"
																	viewBox="0 0 18 13"
																	fill="none"
																	xmlns="http://www.w3.org/2000/svg"
																>
																	<path
																		d="M5.99914 10.1998L2.49914 6.69982C2.10914 6.30982 1.48914 6.30982 1.09914 6.69982C0.709141 7.08982 0.709141 7.70982 1.09914 8.09982L5.28914 12.2898C5.67914 12.6798 6.30914 12.6798 6.69914 12.2898L17.2991 1.69982C17.6891 1.30982 17.6891 0.689824 17.2991 0.299824C16.9091 -0.0901758 16.2891 -0.0901758 15.8991 0.299824L5.99914 10.1998Z"
																		fill="#452C8E"
																	/>
																</svg>
															</div>
														</div>
													) : (
														<></>
													)}
												</div>
											);
										})
									) : (
										<></>
									)}
								</div>
							</div>
						</div>
					</div>
					{taskInfo?.members && taskInfo?.members?.length > 0
						? taskInfo?.members?.map((member, idx) => {
								return (
									<div key={member.id} className="item">
										{idx < moreMember && (
											<Tooltip
												title={member?.name}
												placement="top"
												arrow
												className="cursor-pointer"
											>
												<span>
													{member?.profilePicDocument ? (
														<img
															src={member.profilePicDocument?.docUrl}
															alt={member.memberName}
															title={member.memberName}
														/>
													) : (
														<img
															src={`${process.env.PUBLIC_URL}/images/pro_pic_default.svg`}
															alt={member.memberName}
															title={member.memberName}
														/>
													)}
												</span>
											</Tooltip>
										)}
									</div>
								);
							})
						: null}

					{taskInfo?.members?.length > moreMember && (
						<div className="more-people cursor-pointer more">
							<span onClick={() => setShowMemberModal(!showAddNewMemberModal)}>
								+{taskInfo?.members?.length - moreMember}
							</span>
						</div>
					)}
				</div>
			</div>
		</LoaderComponent>
	);
};

export default AssignMemberToOrderStage;
